import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { Nav } from 'react-bootstrap';
import labill1 from './../assets/img/Illustrations/Laboratory-amico.svg';
import setupIcon from '../assets/img/Icons/setup-icon.png';
import affordableCost from '../assets/img/Icons/affordable-cost.png';
import efficiancy from '../assets/img/Icons/efficiancy.png';
import productivity from '../assets/img/Icons/productivity.png';

const TLimsFrame = () => {
    const [activeFeature, setActiveFeature] = useState(0);
    
    const features = [
        {
            title: "Automated Sample Lifecycle Management ",
            description: "Digitizes and streamlines the entire sample journey from login to disposal, ensuring traceability and minimizing manual errors.",
            icon: setupIcon
        },
        {
            title: "Regulatory-Ready Compliance Framework",
            description: "Facilitates adherence to global standards like ISO 17025, ISO 13485, and FDA regulations through automated documentation and audit readiness.",
            icon: affordableCost
        },
        {
            title: "Centralized Test Data Management",
            description: "Consolidates test methods, results, and reports in a unified platform, enhancing data integrity, accessibility, and operational efficiency.",
            icon: efficiancy
        },
        {
            title: "Real-Time Reporting and Certificate Generation",
            description: "Speeds up result delivery with automated CoA generation and real-time analytics, improving turnaround times and client satisfaction.",
            icon: productivity
        }
    ];

    return (
       <div className="tlims-main">
            <section id="tlims" className="tlims-section">
                <div className="tlims-container">
                    <div className="tlims-header">
                        <h2 className="tlims-title" style={{textAlign:'center'}}>Lab Iconics T-LIMS</h2>
                        <p className="tlims-subtitle">
                            Lab Iconics Testing Laboratory Information Management System designed to streamline sample testing workflows, 
                            ensuring efficient data management and regulatory compliance for modern laboratories.
                        </p>
                    </div>
                    
                    <div className="tlims-content">
                        <div className="tlims-features">
                            {features.map((feature, index) => (
                            <div 
                                key={index}
                                className={`tlims-feature-card active ${activeFeature === index ? '' : ''}`}
                                onMouseEnter={()=> setActiveFeature(index)}
                                // onClick={() => setActiveFeature(index)} ${activeFeature === index ? 'active' : 'active'}
                            >
                                <div className="tlims-feature-icon">
                                    <div className="icon-placeholder">
                                        <img src={feature.icon} alt="icon" />
                                    </div>
                                </div>
                                <div className="tlims-feature-text">
                                    <h3>{feature.title}</h3>
                                    <p className="tlims-feature-description">{feature.description}</p>
                                </div>
                            </div>
                            ))}
                        </div>

                        <div className='learn-more-div' style={{margin:'0'}}>
                            <Nav.Link as={Link} to='/tlims' href='#TLIMS'>
                                <div className='learn-more-btn' style={{backgroundColor:'#6366f11d'}}>
                                    <span>Explore</span>
                                    <div className="arrow arrow--right">
                                        <span></span>
                                    </div>
                                </div>
                            </Nav.Link>
                        </div>
                        
                        <div className="tlims-visual">
                            <div className="tlims-image-container">
                                <div className="tlims-image-placeholder">
                                    <img src={labill1} alt="tlims" />
                                </div>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </section>
       </div>
    );
};

export default TLimsFrame;